import api from '../axios'

export default {
  getAll() {
    return api.get('/categories')  // coincide con tu ruta en Laravel
  }
}
